module.exports = __webpack_public_path__ + "img/tos_p.1c2caf8f.svg";